<template>
  <div class="sidebar shadow bg-dark text-dark col-md-3 col-lg-2 d-md-block">
    <header class="b-sidebar-header d-flex justify-content-center py-5 px-2">
      <img src="@/assets/img/logo-admin.png" alt="">
    </header>

    <div class="b-sidebar-body" v-if="permission.data">
      <div>
        <nav>
          <ul class="nav flex-column">
            <router-link class="text-white d-block text-decoration-none" to="/administrator/dashboard" v-if="memberPermission[0].permission === 'all'">
              <li class="nav-link p-0 border-bottom">
                <div class="pl-3 my-2" :class="{ active: isActive('administrator/dashboard') }">
                    ダッシュボード
                </div>
              </li>
            </router-link>

            <template v-if="propertyPermission[0].permission === 'all'">
              <router-link v-for="type in ['business', 'rental-residential', 'rental-commercial']" :key="type" class="text-white d-block text-decoration-none" :to="{ name: 'Property List', params: { type: type }}">
                <li class="nav-link p-0" :class="bottomBorder(propertyPermission[0].permission, memberPermission[0].permission)">
                  <div class="pl-3 my-2" :class="{ active: ['Property List', 'Add New Property', 'Edit Property Information'].includes($route.name) && $route.params.type === type }" v-html="$t(`${type}-property`)"></div>
                </li>
              </router-link>
            </template>

            <router-link class="text-white d-block text-decoration-none" to="/administrator/blog-list"  v-if="blogPermission[0].permission === 'all'">
              <li class="nav-link p-0">
                <div class="pl-3 my-2" :class="{ active: isActive('administrator/blog-list') || isActive('administrator/new-blog') || isActive('administrator/edit-blog/') || isActive('administrator/edit-blog/' + this.$route.params.id) || isActive('administrator/edit-blog/' + this.$route.params.id + '/' + this.$route.params.language) }">
                    ブログ
                </div>
              </li>
            </router-link>
            <router-link class="text-white d-block text-decoration-none" to="/administrator/email-list" v-if="magazinePermission[0].permission === 'all'">
              <li class="nav-link p-0">
                <div class="pl-3 my-2" :class="{ active: isActive('administrator/email-list') || isActive('administrator/new-email') || isActive('administrator/edit-email/' + this.$route.params.id) }">
                    メッセージ
                </div>
              </li>
            </router-link>
            <router-link class="text-white d-block text-decoration-none" to="/administrator/memberList" v-if="memberPermission[0].permission === 'all'">
              <li class="border-bottom nav-link p-0">
                <div class="pl-3 my-2" :class="{ active: isActive('administrator/memberList') || isActive('administrator/new-member') || isActive('administrator/edit-member/' + this.$route.params.id) }">
                    会員情報
                </div>
              </li>
            </router-link>
            <div class="fixed-bottom position-absolute">
              <ul class="nav flex-column p-3">
                <router-link class="text-white d-block text-decoration-none" to="/administrator/admin-list">
                  <li class="nav-link p-0 border-bottom">
                    <div class="pl-3 my-2" :class="{ active: isActive('administrator/admin-list') || isActive('administrator/admin-register') || isActive('administrator/edit-admin-super/' + this.$route.params.id) }">
                        管理者情報
                    </div>
                  </li>
                </router-link>
                <li class="my-2 nav-link p-0 pl-3">
                  <a href="#"  class="text-white d-block text-decoration-none" @click="logout">ログアウト</a>
                </li>
              </ul>
            </div>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    let url = window.location.pathname
    url = url.substr(1)
    return { activeItem: url }
  },
  created () {
    this.getPermission()
  },
  computed: {
    ...mapState('adminAccount', ['permission']),
    propertyPermission: function () {
      return this.permission.data
        .filter(this.postPermissionFilter)
    },
    adminPermission: function () {
      return this.permission.data
        .filter(this.filterByAdminType)
    },
    magazinePermission: function () {
      return this.permission.data
        .filter(this.magazinePermissionFilter)
    },
    blogPermission: function () {
      return this.permission.data
        .filter(this.blogPermissionFilter)
    },
    memberPermission: function () {
      return this.permission.data
        .filter(this.memberPermissionFilter)
    }
  },
  methods: {
    ...mapActions('login', ['sendLogoutRequest']),
    ...mapActions('adminAccount', ['getPermission']),
    isActive: function (url) {
      return this.activeItem === url
    },
    postPermissionFilter: function (data) {
      return (data.subject === 'properties')
    },
    magazinePermissionFilter: function (data) {
      return (data.subject === 'blog_articles')
    },
    memberPermissionFilter: function (data) {
      return (data.subject === 'member_accounts')
    },
    blogPermissionFilter: function (data) {
      return (data.subject === 'magazines')
    },
    filterByAdminType: function (data) {
      return (data.subject === 'administrator_accounts')
    },
    logout: function () {
      this.sendLogoutRequest()
    },
    bottomBorder: function (property, member) {
      if (property === 'all' && member === 'none') {
        return 'border-bottom'
      }
      return null
    }
  }
}
</script>
